(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gzh-responsive-slideshow"] && !Shopify.designMode) return;
  try {
    
  {
    class GzhResponsiveSlideshowComponent extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-slideshow-track]');
      this.slides = Array.from(this.querySelectorAll('[data-slideshow-slide]'));
      this.dots = Array.from(this.querySelectorAll('[data-slideshow-dot]'));
      this.prevButton = this.querySelector('[data-slideshow-prev]');
      this.nextButton = this.querySelector('[data-slideshow-next]');
      this.index = 0;
      this.timer = null;

      if (!this.track || this.slides.length < 1) return;

      this.prevButton?.addEventListener('click', () => this.select(this.index - 1, true));
      this.nextButton?.addEventListener('click', () => this.select(this.index + 1, true));

      this.dots.forEach((dot) => {
        dot.addEventListener('click', () => this.select(Number(dot.dataset.index), true));
      });

      this.addEventListener('mouseenter', () => this.stop());
      this.addEventListener('mouseleave', () => this.start());
      this.addEventListener('focusin', () => this.stop());
      this.addEventListener('focusout', () => this.start());

      this.bindTouch();
      this.select(0, false);
      this.start();
    }

    disconnectedCallback() {
      this.stop();
    }

    bindTouch() {
      let startX = 0;
      let startY = 0;

      this.addEventListener(
        'touchstart',
        (event) => {
          startX = event.touches[0].clientX;
          startY = event.touches[0].clientY;
        },
        { passive: true }
      );

      this.addEventListener(
        'touchend',
        (event) => {
          const endX = event.changedTouches[0].clientX;
          const endY = event.changedTouches[0].clientY;
          const distanceX = endX - startX;
          const distanceY = endY - startY;

          if (Math.abs(distanceX) < 40 || Math.abs(distanceX) < Math.abs(distanceY)) return;

          this.select(this.index + (distanceX < 0 ? 1 : -1), true);
        },
        { passive: true }
      );
    }

    select(nextIndex, restart) {
      const total = this.slides.length;
      this.index = (nextIndex + total) % total;
      this.track.style.transform = `translateX(-${this.index * 100}%)`;

      this.slides.forEach((slide, slideIndex) => {
        const isActive = slideIndex === this.index;
        slide.setAttribute('aria-hidden', isActive ? 'false' : 'true');
        slide.toggleAttribute('inert', !isActive);
      });

      this.dots.forEach((dot, dotIndex) => {
        if (dotIndex === this.index) {
          dot.setAttribute('aria-current', 'true');
        } else {
          dot.removeAttribute('aria-current');
        }
      });

      if (restart) {
        this.stop();
        this.start();
      }
    }

    start() {
      if (this.dataset.autoplay !== 'true' || this.slides.length < 2 || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

      const interval = Number(this.dataset.interval) || 5000;
      this.stop();
      this.timer = window.setInterval(() => this.select(this.index + 1, false), interval);
    }

    stop() {
      if (!this.timer) return;

      window.clearInterval(this.timer);
      this.timer = null;
    }
    }

    if (!customElements.get('gzh-responsive-slideshow-component')) {
      customElements.define('gzh-responsive-slideshow-component', GzhResponsiveSlideshowComponent);
    }
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gzh-review-video-slider-pro"] && !Shopify.designMode) return;
  try {
    
  class GzhReviewVideoSlider extends HTMLElement {
    connectedCallback() {
      this.slider = this;
      this.section = this.closest('.gzh-review-video-slider-pro');
      this.prev = this.section?.querySelector('[data-gzh-rvsp-prev]');
      this.next = this.section?.querySelector('[data-gzh-rvsp-next]');
      this.mobileView = Number.parseFloat(this.dataset.mobileView) || 1.4;
      this.desktopView = Number.parseFloat(this.dataset.desktopView) || 5;
      this.desktopDepth = Number.parseInt(this.dataset.desktopDepth, 10) || 240;
      this.originalSlideCount = this.querySelectorAll('.swiper-slide:not(.gzh-review-video-slider-pro__slide--clone)').length;
      this.loopSets = 7;
      this.loopMiddleSet = Math.floor(this.loopSets / 2);

      this.ensureLoopSlides();
      this.hydrateExternalPosters();
      this.playButtons = Array.from(this.querySelectorAll('[data-gzh-rvsp-play]'));
      this.videos = Array.from(this.querySelectorAll('video'));

      this.bindPressedLinks();
      this.bindPlayback();
      this.initSwiper();
    }

    disconnectedCallback() {
      this.stopAll();
      if (this.swiper) this.swiper.destroy(true, true);
    }

    bindPressedLinks() {
      this.querySelectorAll('.gzh-review-video-slider-pro__link').forEach((link) => {
        link.addEventListener('pointerdown', () => link.classList.add('is-pressed'));
        link.addEventListener('pointerup', () => link.classList.remove('is-pressed'));
        link.addEventListener('pointercancel', () => link.classList.remove('is-pressed'));
        link.addEventListener('pointerleave', () => link.classList.remove('is-pressed'));
      });
    }

    bindPlayback() {
      this.playButtons.forEach((button) => {
        button.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();

          const card = button.closest('.gzh-review-video-slider-pro__card');
          const video = card?.querySelector('video');
          const embed = card?.querySelector('[data-gzh-rvsp-embed]');

          if (embed) {
            const platform = this.getResolvedPlatform(embed);
            if (platform === 'instagram' || platform === 'tiktok') {
              const externalUrl = embed.dataset.url || button.dataset.videoUrl;
              if (externalUrl) window.open(externalUrl, '_blank', 'noopener');
              return;
            }

            if (card.classList.contains('is-playing')) {
              this.clearEmbed(embed);
              card.classList.remove('is-playing');
              return;
            }

            this.stopAll();
            this.loadExternalVideo(embed, card);
            return;
          }

          if (!video) return;

          if (card.classList.contains('is-playing')) {
            video.pause();
            card.classList.remove('is-playing');
            return;
          }

          this.stopAll(video);
          video.muted = false;
          video.play().then(() => {
            card.classList.add('is-playing');
          }).catch(() => {
            video.muted = true;
            video.play().then(() => card.classList.add('is-playing')).catch(() => {});
          });
        });
      });

      this.videos.forEach((video) => {
        video.addEventListener('ended', () => {
          video.closest('.gzh-review-video-slider-pro__card')?.classList.remove('is-playing');
        });
      });
    }

    initSwiper() {
      if (typeof Swiper === 'undefined') {
        window.setTimeout(() => this.initSwiper(), 80);
        return;
      }

      this.swiper = new Swiper(this.slider, {
        effect: 'coverflow',
        centeredSlides: true,
        grabCursor: true,
        speed: 300,
        loop: false,
        rewind: false,
        initialSlide: this.getMiddleStartIndex(),
        slidesPerView: this.mobileView,
        spaceBetween: 16,
        watchSlidesProgress: true,
        coverflowEffect: {
          rotate: 0,
          stretch: 0,
          depth: 160,
          modifier: 1,
          slideShadows: false
        },
        navigation: {
          nextEl: this.next,
          prevEl: this.prev
        },
        breakpoints: {
          768: {
            slidesPerView: this.mobileView,
            spaceBetween: 16,
            coverflowEffect: {
              rotate: 0,
              stretch: 0,
              depth: 160,
              modifier: 1,
              slideShadows: false
            }
          },
          1024: {
            slidesPerView: this.desktopView,
            spaceBetween: 0,
            coverflowEffect: {
              rotate: 0,
              stretch: 0,
              depth: this.desktopDepth,
              modifier: 1,
              slideShadows: false
            }
          },
          1500: {
            slidesPerView: this.desktopView,
            spaceBetween: 0,
            coverflowEffect: {
              rotate: 0,
              stretch: 0,
              depth: this.desktopDepth,
              modifier: 1,
              slideShadows: false
            }
          }
        },
        on: {
          slideChange: () => this.stopAll(),
          transitionEnd: () => this.recenterIfNeeded()
        }
      });
    }

    ensureLoopSlides() {
      const wrapper = this.querySelector('.swiper-wrapper');
      if (!wrapper || this.dataset.loop !== 'true') return;

      const originalSlides = Array.from(wrapper.children);
      if (originalSlides.length < 2 || wrapper.dataset.loopHydrated === 'true') return;

      wrapper.innerHTML = '';

      for (let setIndex = 0; setIndex < this.loopSets; setIndex += 1) {
        originalSlides.forEach((slide, slideIndex) => {
          const nextSlide = slide.cloneNode(true);
          if (setIndex !== this.loopMiddleSet) {
            nextSlide.removeAttribute('data-shopify-editor-block');
            nextSlide.removeAttribute('shopify_attributes');
            nextSlide.classList.add('gzh-review-video-slider-pro__slide--clone');
            nextSlide.setAttribute('aria-hidden', 'true');
          }
          nextSlide.dataset.originalIndex = String(slideIndex);
          wrapper.appendChild(nextSlide);
        });
      }

      wrapper.dataset.loopHydrated = 'true';
    }

    getMiddleStartIndex() {
      if (this.dataset.loop !== 'true' || this.originalSlideCount < 2) return 0;

      return this.originalSlideCount * this.loopMiddleSet;
    }

    recenterIfNeeded() {
      if (!this.swiper || this.dataset.loop !== 'true' || this.originalSlideCount < 2) return;

      const index = this.swiper.activeIndex;
      const lowerBound = this.originalSlideCount;
      const upperBound = this.originalSlideCount * (this.loopSets - 1);

      if (index >= lowerBound && index < upperBound) return;

      const originalIndex = Number(this.swiper.slides[index]?.dataset.originalIndex || 0);
      this.swiper.slideTo(this.getMiddleStartIndex() + originalIndex, 0, false);
    }

    hydrateExternalPosters() {
      this.querySelectorAll('[data-gzh-rvsp-embed]').forEach((embed) => {
        if (embed.parentElement?.querySelector('.gzh-review-video-slider-pro__poster--video')) return;

        const url = embed.dataset.url || '';
        const detectedPlatform = this.getResolvedPlatform(embed);
        const posterUrl = this.getPosterUrl(url, detectedPlatform);
        if (detectedPlatform === 'instagram' || detectedPlatform === 'tiktok') {
          this.addExternalLink(embed, detectedPlatform);
        }

        if (posterUrl) {
          this.appendPoster(embed, posterUrl, detectedPlatform, url);
          return;
        }

        if (detectedPlatform === 'tiktok') {
          this.hydrateTikTokPoster(embed, url);
        }
      });
    }

    appendPoster(embed, posterUrl, detectedPlatform, sourceUrl = '') {
        const image = document.createElement('img');
        image.className = 'gzh-review-video-slider-pro__poster gzh-review-video-slider-pro__poster--video';
        image.src = posterUrl;
        if (detectedPlatform === 'youtube') {
          const id = this.getYouTubeId(sourceUrl);
          if (id) image.dataset.fallbackSrc = `https://i.ytimg.com/vi/${id}/hqdefault.jpg`;
        }
        image.alt = '';
        image.loading = 'lazy';
        image.addEventListener('error', () => {
          if (image.dataset.fallbackSrc && image.src !== image.dataset.fallbackSrc) {
            image.src = image.dataset.fallbackSrc;
            image.removeAttribute('data-fallback-src');
            return;
          }
          image.remove();
        });
        embed.parentElement?.appendChild(image);
    }

    addExternalLink(embed, platform) {
      if (embed.parentElement?.querySelector('.gzh-review-video-slider-pro__external-link')) return;

      const link = document.createElement('a');
      link.className = 'gzh-review-video-slider-pro__external-link';
      link.href = embed.dataset.url || '#';
      link.target = '_blank';
      link.rel = 'noopener';
      link.textContent = platform === 'tiktok' ? '在 TikTok 查看' : '在 Instagram 查看';
      embed.parentElement?.appendChild(link);
    }

    hydrateTikTokPoster(embed, url) {
      if (!url || !window.fetch) return;

      fetch(`https://www.tiktok.com/oembed?url=${encodeURIComponent(url)}`)
        .then((response) => (response.ok ? response.json() : null))
        .then((data) => {
          if (!data?.thumbnail_url || embed.parentElement?.querySelector('.gzh-review-video-slider-pro__poster--video')) return;
          this.appendPoster(embed, data.thumbnail_url, 'tiktok', url);
        })
        .catch(() => {});
    }

    getResolvedPlatform(embed) {
      const platform = embed.dataset.platform || 'auto';
      return platform === 'auto' ? this.detectPlatform(embed.dataset.url || '') : platform;
    }

    stopAll(exceptVideo = null) {
      this.videos.forEach((video) => {
        if (video === exceptVideo) return;
        video.pause();
        video.closest('.gzh-review-video-slider-pro__card')?.classList.remove('is-playing');
      });

      this.querySelectorAll('[data-gzh-rvsp-embed]').forEach((embed) => {
        this.clearEmbed(embed);
        embed.closest('.gzh-review-video-slider-pro__card')?.classList.remove('is-playing');
      });
    }

    clearEmbed(embed) {
      embed.replaceChildren();
    }

    loadExternalVideo(embed, card) {
      const url = embed.dataset.url || '';
      const detectedPlatform = this.getResolvedPlatform(embed);

      if (detectedPlatform === 'direct') {
        const video = document.createElement('video');
        video.src = url;
        video.controls = true;
        video.autoplay = true;
        video.loop = true;
        video.playsInline = true;
        embed.replaceChildren(video);
        video.play().catch(() => {});
        card.classList.add('is-playing');
        return;
      }

      const embedUrl = this.getEmbedUrl(url, detectedPlatform);
      if (!embedUrl) return;

      const iframe = document.createElement('iframe');
      iframe.src = embedUrl;
      iframe.loading = 'lazy';
      iframe.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
      iframe.allowFullscreen = true;
      iframe.title = 'Review video';
      embed.replaceChildren(iframe);
      card.classList.add('is-playing');
    }

    getEmbedUrl(url, platform) {
      if (!url) return '';

      const value = url.trim();
      const detectedPlatform = platform === 'auto' ? this.detectPlatform(value) : platform;

      if (detectedPlatform === 'youtube') return this.getYouTubeEmbedUrl(value);
      if (detectedPlatform === 'instagram') return this.getInstagramEmbedUrl(value);
      if (detectedPlatform === 'tiktok') return this.getTikTokEmbedUrl(value);

      return value;
    }

    getPosterUrl(url, platform) {
      if (platform === 'youtube') {
        const id = this.getYouTubeId(url);
        return id ? `https://i.ytimg.com/vi/${id}/maxresdefault.jpg` : '';
      }

      if (platform === 'instagram') {
        const data = this.getInstagramData(url);
        return data.code ? `https://www.instagram.com/${data.type}/${data.code}/media/?size=l` : '';
      }

      return '';
    }

    detectPlatform(url) {
      if (/youtu\.be|youtube\.com/i.test(url)) return 'youtube';
      if (/instagram\.com/i.test(url)) return 'instagram';
      if (/tiktok\.com/i.test(url)) return 'tiktok';
      if (/\.(mp4|mov|m4v|webm)(\?|#|$)/i.test(url)) return 'direct';
      return 'direct';
    }

    getYouTubeEmbedUrl(url) {
      const id = this.getYouTubeId(url);

      return id ? `https://www.youtube.com/embed/${id}?autoplay=1&mute=1&playsinline=1&rel=0` : url;
    }

    getYouTubeId(url) {
      try {
        const parsed = new URL(url);

        if (parsed.hostname.includes('youtu.be')) {
          return parsed.pathname.split('/').filter(Boolean)[0] || '';
        }
        if (parsed.pathname.includes('/shorts/')) {
          return parsed.pathname.split('/shorts/')[1]?.split('/')[0] || '';
        }
        if (parsed.pathname.includes('/embed/')) {
          return parsed.pathname.split('/embed/')[1]?.split('/')[0] || '';
        }

        return parsed.searchParams.get('v') || '';
      } catch (error) {
        return '';
      }
    }

    getInstagramEmbedUrl(url) {
      const data = this.getInstagramData(url);

      return data.code ? `https://www.instagram.com/${data.type}/${data.code}/embed` : url;
    }

    getInstagramData(url) {
      try {
        const parsed = new URL(url);
        const parts = parsed.pathname.split('/').filter(Boolean);
        const type = parts[0] === 'reel' ? 'reel' : 'p';
        const code = parts[1] || '';

        return { type, code };
      } catch (error) {
        return { type: 'p', code: '' };
      }
    }

    getTikTokEmbedUrl(url) {
      try {
        const parsed = new URL(url);
        const match = parsed.pathname.match(/\/video\/(\d+)/);

        return match?.[1] ? `https://www.tiktok.com/embed/v2/${match[1]}` : url;
      } catch (error) {
        return url;
      }
    }
  }

  if (!customElements.get('gzh-review-video-slider')) {
    customElements.define('gzh-review-video-slider', GzhReviewVideoSlider);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
